export const P256_DID_PREFIX = new Uint8Array([0x80, 0x24])
export const SECP256K1_DID_PREFIX = new Uint8Array([0xe7, 0x01])
export const BASE58_DID_PREFIX = 'did:key:z' // z is the multibase prefix for base58btc byte encoding

export const P256_JWT_ALG = 'ES256'
export const SECP256K1_JWT_ALG = 'ES256K'
